import { useState, useEffect } from 'react';
import { API, Endpoints } from '@brg/api';

interface DownloadRoomUrl {
  platform: number;
  downloadURL: string;
}

interface MetaverseProject {
  projectId: string;
  downloadRoomUrl?: DownloadRoomUrl[];
}

export const useGetProjectPackages = (projectId?: string, shouldFetch: boolean = true) => {
  const [downloadRoomUrls, setDownloadRoomUrls] = useState<DownloadRoomUrl[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!projectId || !shouldFetch) {
      setDownloadRoomUrls([]);
      setIsLoading(false);
      return;
    }

    const fetchProject = async () => {
      setIsLoading(true);

      try {
        const response = await API.request()
          .endpoint(Endpoints.gateway)
          .url(`metaverse/api/Project/GetProject/${projectId}`)
          .get()
          .send();

        if (response.status === 404) {
          setDownloadRoomUrls([]);
          return;
        }

        const data: MetaverseProject = await response.json();
        setDownloadRoomUrls(data.downloadRoomUrl || []);
      } catch (err) {
        setDownloadRoomUrls([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProject();
  }, [projectId, shouldFetch]);

  return { downloadRoomUrls, isLoading };
};

import { useState, useEffect } from 'react';
import { API, Endpoints } from '@brg/api';

interface DownloadRoomUrl {
  platform: number;
  downloadURL: string;
}

interface MetaverseProject {
  projectId: string;
  downloadRoomUrl?: DownloadRoomUrl[];
}

export const useGetProjectPackages = (projectId?: string, shouldFetch: boolean = true) => {
  const [downloadRoomUrls, setDownloadRoomUrls] = useState<DownloadRoomUrl[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!projectId || !shouldFetch) {
      setDownloadRoomUrls([]);
      setIsLoading(false);
      return;
    }

    const fetchProject = async () => {
      setIsLoading(true);

      try {
        const response = await API.request()
          .endpoint(Endpoints.gateway)
          .url(`metaverse/api/Project/GetProject/${projectId}`)
          .get()
          .send();

        if (response.status === 404) {
          setDownloadRoomUrls([]);
          return;
        }

        const data: MetaverseProject = await response.json();
        setDownloadRoomUrls(data.downloadRoomUrl || []);
      } catch (err) {
        setDownloadRoomUrls([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProject();
  }, [projectId, shouldFetch]);

  return { downloadRoomUrls, isLoading };
};

